import { ref, type Ref } from 'vue'

type SortEntry = { key: string; order: 'asc' | 'desc' }

/**
 * Provides a sort state that mimics Vuetify 2 behavior:
 * - Only two states: asc → desc → asc → …
 * - No neutral (gray) state.
 */
export function useVue2Sort(initialSort?: SortEntry) {
  const sortBy = ref<SortEntry[]>(initialSort ? [initialSort] : [])

  function onUpdateSortBy(newSort: SortEntry[]) {
    // If the user tries to clear sorting (empty array), keep sorting and toggle to 'asc'
    if (newSort.length === 0) {
      const currentKey = sortBy.value[0]?.key
      if (currentKey) {
        // Force ascending on the currently sorted column
        sortBy.value = [{ key: currentKey, order: 'asc' }]
      }
      return
    }
    // Otherwise, accept the new sort (asc or desc)
    sortBy.value = newSort
  }

  return {
    sortBy,           // readonly for the template – use v-model:page syntax but :sort-by + @update
    onUpdateSortBy,
  }
}
